import { classNames } from "app/components/propertiesPage/PropertiesComponent";
import * as React from "react";

interface props {
  className?: string;
}
const CalendarSingleDotIcon = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#262626"
      d="M14.885 18a2.04 2.04 0 0 1-1.496-.62 2.04 2.04 0 0 1-.62-1.495q0-.874.62-1.497a2.03 2.03 0 0 1 1.496-.619 2.06 2.06 0 0 1 1.496.62q.62.617.619 1.496a2.04 2.04 0 0 1-.62 1.496q-.618.617-1.495.619m-9.27 3q-.69 0-1.152-.462T4 19.385V6.615q0-.69.463-1.152A1.57 1.57 0 0 1 5.616 5h1.769V2.77h1.077V5h7.154V2.77h1V5h1.769q.69 0 1.153.463T20 6.616v12.769q0 .69-.462 1.153T18.384 21zm0-1h12.77a.6.6 0 0 0 .423-.192.58.58 0 0 0 .192-.424v-8.768H5v8.769a.6.6 0 0 0 .192.423.58.58 0 0 0 .423.192M5 9.615h14v-3a.6.6 0 0 0-.192-.423.58.58 0 0 0-.424-.192H5.616a.6.6 0 0 0-.424.192.58.58 0 0 0-.192.424z"
    ></path>
  </svg>
);

export default CalendarSingleDotIcon;
